import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Error: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M16 1.5C7.98546 1.5 1.5 7.99864 1.5 16c0 8.0014 6.48546 14.5 14.5 14.5 8.0145 0 14.5-6.4855 14.5-14.5 0-8.01454-6.4855-14.5-14.5-14.5Zm-1.3182 5.27273h2.6364V18.6364h-2.6364V6.77273ZM16 25.2273c-1.0941 0-1.9773-.8832-1.9773-1.9773s.8832-1.9773 1.9773-1.9773 1.9773.8832 1.9773 1.9773-.8832 1.9773-1.9773 1.9773Z"
    />
  </Icon>
);
